import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEnumEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchInstrumentTypesThunk: any = createAsyncThunk<IBindBaseEnumEntity[]>(
  `${prefix} fetchInstrumentTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getInstrumentTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch instrument. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
